import { BQ_ERROR_CODES } from "@costory/types/endpoints/billingDatasources"

// Use constants and improve type safety
export const getBqErrorMessage = (
  errorCode?: keyof typeof BQ_ERROR_CODES,
  tablePath?: string,
): string => {
  const formatPath = (path?: string) =>
    path ? `"${path}"` : "the provided path"

  const errorMessages = {
    [BQ_ERROR_CODES.INVALID_FORMAT]:
      "The table path should be in the format: project.dataset.table",
    [BQ_ERROR_CODES.ACCESS_DENIED]:
      "You don't have permission to access this table. Please check your credentials and permissions.",
    [BQ_ERROR_CODES.DATASET_NOT_FOUND]: `The dataset ${formatPath(tablePath)} does not exist or you don't have access to it.`,
    [BQ_ERROR_CODES.TABLE_NOT_FOUND]: `The table ${formatPath(tablePath)} does not exist or you don't have access to it.`,
    [BQ_ERROR_CODES.NOT_FOUND]: `The path ${formatPath(tablePath)} does not exist or you don't have access to it.`,
    [BQ_ERROR_CODES.CREDENTIALS]:
      "Failed to authenticate with BigQuery. Please check your credentials.",
    [BQ_ERROR_CODES.BUCKET]:
      "The specified bucket does not exist or you don't have access to it.",
    [BQ_ERROR_CODES.REPLICATION_NOT_ENABLED]:
      "Costory currently does not support non EU location for your billing data stored in BigQuery: Could you enable the dataset replication in EU as explained in the docs (dataset replication: https://help.costory.io/en/articles/10982158-set-up-documentation-google-cloud-platform-x-costory#h_7521f764f2).",
    [BQ_ERROR_CODES.UNKNOWN_ERROR]: `The path ${formatPath(tablePath)} is invalid. Check the format (project.dataset.table) or your permissions.`,
  }

  return errorMessages[errorCode || BQ_ERROR_CODES.UNKNOWN_ERROR]
}
